import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Component_3.css";

const Component_3 = ({ focusData, showTitle = true }) => {
  return (
    <section className="focus-section">
      <Container>
        {showTitle && <h3 className="focus-title">We Focus On</h3>}
        <Row>
          {focusData.map((item, index) => (
            <Col key={index} lg={3} md={4} sm={6} xs={12} className="">
              <div className="focus-card text-center">
                <div className="icondiv">
                  <img className="sporticon" src={item.icon} alt="sport-icon" />
                </div>
                <h5 className="focus-heading">{item.title}</h5>
                <p className="focus-desc">{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Component_3;
